var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { addScroll } from '../internal';
import { cssClass, CSS_CLASS_BODY, CSS_CLASS_FOOTER, CSS_CLASS_HEADER, CSS_CLASS_SCROLLBAR_TESTER, CSS_CLASS_SHIFTED, CSS_CLASS_TBODY, CSS_CLASS_THEAD, } from '../styles';
import StyleManager from './StyleManager';
export function setTemplate(root, id) {
    var cleanId = id.startsWith('#') ? id.slice(1) : id;
    // eslint-disable-next-line no-param-reassign
    root.innerHTML = "\n  <header id=\"header-" + cleanId + "\" class=\"" + CSS_CLASS_HEADER + " " + cssClass("header-" + cleanId) + "\">\n    <article class=\"" + CSS_CLASS_THEAD + " " + cssClass("thead-" + cleanId) + "\"></article>\n  </header>\n  <main id=\"body-" + cleanId + "\" class=\"" + CSS_CLASS_BODY + " " + cssClass("body-" + cleanId) + "\">\n    <footer class=\"" + CSS_CLASS_FOOTER + "\">&nbsp;</footer>\n    <article class=\"" + CSS_CLASS_TBODY + " " + cssClass("tbody-" + cleanId) + "\"></article>\n  </main>";
    return root;
}
/**
 * generates the HTML Ids used for the header and body article of a table
 * @param {string} tableId base table id
 * @param {boolean} asSelector flag whether to prepend with # for CSS selector
 * @return {ISelectors} the table ids used for header and body
 */
export function tableIds(tableId) {
    return {
        thead: "thead-" + tableId,
        tbody: "tbody-" + tableId,
        tr: "tr-" + tableId,
        th: "th-" + tableId,
        td: "td-" + tableId,
    };
}
export function tableCSSClasses(tableId) {
    var ids = tableIds(tableId);
    return {
        thead: cssClass(ids.thead),
        tbody: cssClass(ids.tbody),
        tr: cssClass(ids.tr),
        th: cssClass(ids.th),
        td: cssClass(ids.td),
    };
}
/**
 * utility for custom generated CSS rules with a focus on dynamically generated grid layouts
 */
var GridStyleManager = /** @class */ (function (_super) {
    __extends(GridStyleManager, _super);
    function GridStyleManager(root, id) {
        var _this = _super.call(this, root) || this;
        _this.id = id.startsWith('#') ? id.slice(1) : id;
        _this.ids = tableIds(_this.id);
        _this.cssClasses = tableCSSClasses(_this.id);
        var headerScroller = root.getElementsByTagName('header')[0];
        var bodyScroller = root.getElementsByTagName('main')[0];
        // async since style needs to be added to dom first
        // eslint-disable-next-line no-restricted-globals
        self.setTimeout(function () {
            var width = measureScrollbar(root).width;
            _this.updateRule('__scrollBarFix2', "#header-" + _this.id + " > article:last-of-type", {
                borderRight: width + "px solid transparent",
            });
        }, 20);
        var old = headerScroller.scrollLeft;
        // update frozen and sync header with body
        addScroll(bodyScroller, 'animation', function (act) {
            var newValue = act.left;
            if (old !== newValue) {
                headerScroller.scrollLeft = newValue;
                old = newValue;
            }
            root.classList.toggle(CSS_CLASS_SHIFTED, act.left > 0);
        });
        return _this;
    }
    /**
     * updates the column widths and default row height for a table
     * @param {number} defaultRowHeight
     * @param {IColumn[]} columns
     * @param {number} frozenShift shift frozen columns
     * @param {string} tableId optional tableId in case of multiple tables within the same engine
     * @param {string} unit
     */
    GridStyleManager.prototype.update = function (defaultRowHeight, columns, padding, frozenShift, tableId, unit) {
        if (unit === void 0) { unit = 'px'; }
        var ids = tableIds(tableId);
        var selectors = tableCSSClasses(tableId);
        var total = "" + columns.reduce(function (a, b, i) { return a + b.width + padding(i); }, 0) + unit;
        this.updateRule("__heightsRule" + selectors.tr, "." + selectors.tr, {
            height: defaultRowHeight + "px",
            width: total,
        });
        this.updateRule("__heightsRule" + selectors.tbody, "#" + ids.tbody, {
            width: total,
        });
        this.updateColumns(columns, padding, selectors, frozenShift, unit);
    };
    /**
     * removes a given tableId if not needed anymore
     * @param {string} tableId tableId to remove
     */
    GridStyleManager.prototype.remove = function (tableId) {
        var selectors = tableCSSClasses(tableId);
        this.deleteRule("__heightsRule" + selectors.tr);
        this.deleteRule("__heightsRule" + selectors.tbody);
        var prefix = "__col" + selectors.td + "_";
        var rules = this.ruleNames.reduce(function (a, b) { return a + (b.startsWith(prefix) ? 1 : 0); }, 0);
        // reset
        for (var i = 0; i < rules; i += 1) {
            this.deleteRule("" + prefix + i);
        }
    };
    GridStyleManager.prototype.updateColumns = function (columns, padding, cssSelectors, frozenShift, unit) {
        var _this = this;
        if (unit === void 0) { unit = 'px'; }
        var prefix = "__col" + cssSelectors.td + "_";
        var rules = new Set(this.ruleNames.filter(function (d) { return d.startsWith(prefix); }));
        var acc = 0;
        columns.forEach(function (c, i) {
            var th = "." + cssSelectors.th + "[data-id=\"" + c.id + "\"]";
            var thStyles = {
                width: "" + c.width + unit,
            };
            var td = "." + cssSelectors.td + "[data-id=\"" + c.id + "\"]";
            var tdStyles = {
                transform: "translateX(" + acc + unit + ")",
                width: "" + c.width + unit,
            };
            if (c.frozen) {
                thStyles.left = acc + "px";
                _this.updateRule("" + prefix + td + "F", "." + cssSelectors.td + "." + CSS_CLASS_SHIFTED + "[data-id=\"" + c.id + "\"]", {
                    transform: "translateX(0)",
                    left: "" + (acc + frozenShift) + unit,
                });
                rules.delete("" + prefix + td + "F");
            }
            _this.updateRule("" + prefix + th, th, thStyles);
            rules.delete("" + prefix + th);
            _this.updateRule("" + prefix + td, td, tdStyles);
            rules.delete("" + prefix + td);
            acc += c.width + padding(i);
        });
        rules.forEach(function (d) { return _this.deleteRule(d); });
    };
    return GridStyleManager;
}(StyleManager));
export default GridStyleManager;
/**
 * measure the width and height of the scrollbars
 * based on Slick grid implementation
 * @param root
 */
function measureScrollbar(root) {
    var _a;
    var body = (_a = root.ownerDocument) === null || _a === void 0 ? void 0 : _a.body;
    if (!body) {
        return { width: 10, height: 10 };
    }
    body.insertAdjacentHTML('beforeend', "<div class=\"" + CSS_CLASS_SCROLLBAR_TESTER + "\"><div></div></div>");
    var elem = body.lastElementChild;
    var width = elem.offsetWidth - elem.clientWidth;
    var height = elem.offsetHeight - elem.clientHeight;
    elem.remove();
    return { width: width, height: height };
}
//# sourceMappingURL=GridStyleManager.js.map